import { Page } from "../../../../components/Page";
import { useTranslation } from "react-i18next";
import { Button, Center, Divider, Flex, Heading, Icon, Image, Text, useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";
import planStepsImg from "../../../../assets/img/issb/ISSB-plan-steps.png";
import ImageMapper from "react-img-mapper/dist/ImageMapper";
import { FaEnvelope } from "react-icons/fa";
import ISSBHintImage from "../../../../assets/img/issb/ISSB-hint-image.svg";
import { StepModal } from "./components";

function PlanDetails({ planData, handleSendPlan }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails"
  });

  const { isOpen: isModalOpen, onOpen: onModalOpen, onClose: onModalClose } = useDisclosure();
  const [stepIndex, setStepIndex] = useState();

  const onClickHandler = (area) => {
    if (area && !isNaN(area.name)) {
      setStepIndex(area.name);
      onModalOpen();
    }
  };

  const planStepsMap = {
    name: "plan-steps-map",
    areas: [
      { name: 1, shape: "poly", coords: [133, 0, 258, 0, 280, 50, 258, 100, 133, 100] },
      { name: 2, shape: "poly", coords: [265, 0, 410, 0, 435, 50, 410, 100, 265, 100, 288, 50] },
      { name: 3, shape: "poly", coords: [418, 0, 568, 0, 590, 50, 568, 100, 418, 100, 442, 50] },
      { name: 4, shape: "poly", coords: [430, 160, 579, 160, 555, 210, 579, 259, 430, 259, 407, 210] },
      { name: 5, shape: "poly", coords: [275, 160, 424, 160, 401, 210, 424, 259, 275, 259, 252, 210] },
      { name: 6, shape: "poly", coords: [122, 160, 270, 160, 247, 210, 270, 259, 122, 259, 98, 210] },
      { name: 7, shape: "poly", coords: [131, 320, 283, 320, 305, 370, 281, 420, 131, 420, 155, 370] },
      { name: 8, shape: "poly", coords: [287, 320, 436, 320, 460, 370, 436, 420, 287, 420, 310, 370] },
      { name: 9, shape: "poly", coords: [440, 320, 590, 320, 590, 420, 440, 420, 465, 370] }
    ]
  };

  const handleModalClose = () => {
    setStepIndex(null);
    onModalClose();
  };

  return (
    <Page title={t("page.title")}>
      <Center marginBlockStart="2">
        <Text fontSize="xl" textAlign="center">{t("page.subTitle")}</Text>
      </Center>

      <Center marginBlock="10">
        <ImageMapper
          src={planStepsImg}
          map={planStepsMap}
          width={700}
          onClick={area => onClickHandler(area)}
        />
      </Center>

      <Button
        position="sticky"
        top="100px"
        marginLeft="70%"
        colorScheme="customScheme"
        borderRadius={6}
        zIndex={100}
        onClick={handleSendPlan}
      >
        <Flex gap={2} alignItems="end">
          <Icon
            as={FaEnvelope}
            inlineSize="4"
            blockSize="4"
          />
          {t("labels.sendPlanBtn")}
        </Flex>
      </Button>

      <Divider marginBlock={5} opacity={1} />

      <Flex flexFlow="column" alignItems="start" marginBottom={10}>
        <Heading size="lg" textAlign="center" marginBottom={5}>
          {t("labels.didYouKnow")}
        </Heading>
        <Text fontSize="xl">
          {t("labels.hint")}
        </Text>
      </Flex>

      <Flex flexFlow="column" alignItems="center">
        <Image
          src={ISSBHintImage}
          width={"50%"}
        />
      </Flex>

      <StepModal isOpen={isModalOpen} onClose={handleModalClose} stepIndex={stepIndex} data={planData} />
    </Page>
  );
}

export default PlanDetails;